module.exports = __webpack_public_path__ + "img/MY.79cc2d62.svg";